"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPendingSubscriptionUpdate = exports.isPendingSubscriptionDelete = exports.isPendingSubscriptionChange = exports.hasToType = exports.hasToExtraStorage = exports.isApplicable = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = __importDefault(require("lodash"));
const validation_1 = require("../validator/validation");
const datelike_1 = require("../types/datelike");
const uuid_1 = require("../types/uuid");
const instanceType_1 = require("./instanceType");
const isPendingDeleteOperationType = (0, validation_1.isLiteral)('DELETE');
const isPendingUpdateOperationType = (0, validation_1.isLiteral)('UPGRADE', 'DOWNGRADE', 'CREATE');
const isPendingSubscriptionOperationType = (0, validation_1.isSomeOf)(isPendingDeleteOperationType, isPendingUpdateOperationType);
const isApplicable = (pending, atTime = new Date(), withinPeriod = { hours: 24 }) => {
    if (lodash_1.default.isNil(pending)) {
        return false;
    }
    let pendingChange;
    if ((0, datelike_1.isISODate)(pending.appliedAt)) {
        pendingChange = (0, date_fns_1.parseISO)(pending.appliedAt);
    }
    else {
        pendingChange = pending.appliedAt;
    }
    const start = (0, date_fns_1.sub)(atTime, withinPeriod);
    const end = (0, date_fns_1.add)(atTime, withinPeriod);
    return (0, date_fns_1.isWithinInterval)(pendingChange, { start, end });
};
exports.isApplicable = isApplicable;
exports.hasToExtraStorage = (0, validation_1.hasFields)({
    toExtraStorage: validation_1.isNumber.which(validation_1.isNaturalNumber),
});
exports.hasToType = (0, validation_1.hasFields)({
    toType: instanceType_1.isInstanceType,
});
exports.isPendingSubscriptionChange = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)({
    instanceId: uuid_1.isUUID,
    description: (0, validation_1.optional)(validation_1.isString),
    createdAt: (0, validation_1.optional)(datelike_1.isDateLike),
    appliedAt: datelike_1.isDateLike,
    completedAt: (0, validation_1.optional)(datelike_1.isDateLike),
}), (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    operationType: isPendingDeleteOperationType,
}), (0, validation_1.isObjectOf)({
    operationType: isPendingUpdateOperationType,
    toType: instanceType_1.isInstanceType,
    toExtraStorage: validation_1.isUndefined,
}), (0, validation_1.isObjectOf)({
    operationType: isPendingUpdateOperationType,
    toExtraStorage: validation_1.isNaturalNumber,
    toType: validation_1.isUndefined,
}), (0, validation_1.isObjectOf)({
    operationType: isPendingUpdateOperationType,
    toType: instanceType_1.isInstanceType,
    toExtraStorage: validation_1.isNaturalNumber,
})));
exports.isPendingSubscriptionDelete = exports.isPendingSubscriptionChange.which((0, validation_1.satisfiesCondition)(psc => isPendingDeleteOperationType(psc.operationType)));
exports.isPendingSubscriptionUpdate = exports.isPendingSubscriptionChange.which((0, validation_1.satisfiesCondition)(psc => isPendingUpdateOperationType(psc.operationType)));
//# sourceMappingURL=PendingSubscriptionChange.js.map